export const type = {
    GET_VIDEOGAMES: "GET_VIDEOGAMES",
    GET_GENRES: "GET_GENRES",
    FILTER_BY_GENRES: "FILTER_BY_GENRES",
    FILTER_BY_ORIGIN: "FILTER_BY_ORIGIN",
    SORT_BY_NAME: "SORT_BY_NAME",
    SORT_BY_RATING: "SORT_BY_RATING",
    POST_GAME: "POST_GAME",
    GET_DETAIL: "GET_DETAIL",
    GET_PLATFORMS: "GET_PLATFORMS",
    CLEAN_DETAIL: "CLEAN_DETAIL",
  };
  